(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-pl-hero]').forEach(root => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const track = root.querySelector('.pl-hero__slides');
      const slides = [...root.querySelectorAll('.pl-hero__slide')];
      const mobile = window.matchMedia('(max-width:749px)');
      const dots = root.querySelector('.pl-hero__dots');
      const arrows = [...root.querySelectorAll('.pl-hero__arrow')];
      let n = 0, index = 0, timer, startX = 0, startY = 0, dragging = false, dragged = false;
      function set(next) {
        if (!n) return;
        index = (next + n) % n;
        track.style.transform = `translateX(-${index * 100}%)`;
        [...(dots?.children || [])].forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-current', String(i === index));
        });
      }
      function stop() { window.clearInterval(timer); }
      function start() {
        stop();
        if (n > 1 && root.dataset.autoplay === 'true') {
          timer = window.setInterval(() => set(index + 1), Number(root.dataset.speed) || 4000);
        }
      }
      function update() {
        stop(); n = 0; index = 0;
        slides.forEach(slide => {
          slide.hidden = !mobile.matches && slide.dataset.desktopImage !== 'true';
          if (!slide.hidden) n++;
        });
        root.closest('.pl-hero').hidden = n === 0;
        arrows.forEach(arrow => { arrow.hidden = n < 2; });
        if (dots) {
          dots.replaceChildren(); dots.hidden = n < 2;
          for (let i = 0; i < n; i++) {
            const button = document.createElement('button');
            button.type = 'button';
            button.setAttribute('aria-label', `Slayt ${i + 1}`);
            button.addEventListener('click', () => { set(i); start(); });
            dots.appendChild(button);
          }
        }
        track.style.transform = 'translateX(0)'; set(0); start();
      }
      arrows.forEach(arrow => arrow.addEventListener('click', () => {
        set(index + Number(arrow.dataset.dir)); start();
      }));
      root.addEventListener('touchstart', event => {
        if (!event.touches.length) return;
        startX = event.touches[0].clientX; startY = event.touches[0].clientY;
        dragging = true; dragged = false; stop();
      }, { passive: true });
      root.addEventListener('touchmove', event => {
        if (!dragging || !event.touches.length) return;
        const dx = event.touches[0].clientX - startX, dy = event.touches[0].clientY - startY;
        if (Math.abs(dx) > 18 && Math.abs(dx) > Math.abs(dy)) dragged = true;
      }, { passive: true });
      root.addEventListener('touchend', event => {
        if (!dragging) return;
        dragging = false;
        const dx = event.changedTouches[0]?.clientX - startX || 0;
        if (dragged && Math.abs(dx) > 48) set(index + (dx < 0 ? 1 : -1));
        start();
      }, { passive: true });
      root.addEventListener('click', event => {
        if (dragged) { event.preventDefault(); dragged = false; }
      }, true);
      mobile.addEventListener('change', update);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
